import { Schema } from 'effect';
import { LaunchpadIdSchema } from './launchpad';
import { VehicleIdSchema } from './vehicle';

export const LaunchpadAssignmentSchema = Schema.transform(
  Schema.Struct({
    launchpad_id: LaunchpadIdSchema,
    launchpad_letter: Schema.String,
    vehicle_id: VehicleIdSchema
  }),
  Schema.Struct({
    launchpadId: LaunchpadIdSchema,
    launchpadLetter: Schema.String,
    vehicleId: VehicleIdSchema
  }),
  {
    strict: true,
    decode: (api) => ({
      launchpadId: api.launchpad_id,
      launchpadLetter: api.launchpad_letter,
      vehicleId: api.vehicle_id
    }),
    encode: (client) => ({
      launchpad_id: client.launchpadId,
      launchpad_letter: client.launchpadLetter,
      vehicle_id: client.vehicleId
    })
  }
);
export type LaunchpadAssignment = Schema.Schema.Type<typeof LaunchpadAssignmentSchema>;

export const LaunchpadAssignmentsNotificationSchema = Schema.Struct({
  assignments: Schema.optional(Schema.NullOr(Schema.Array(LaunchpadAssignmentSchema)))
});
export type LaunchpadAssignmentsNotification = Schema.Schema.Type<typeof LaunchpadAssignmentsNotificationSchema>;
